<template>
  <div class="maxwidht">
    <div class="shop-page" v-if="shopInfo">
      <header class="shop-header">
        <div class="header-content">
          <div class="header-logo">
            <img class="shop-logo" :src="shopInfo.shoplogo" alt="Shop Logo">
          </div>
          <div class="shop-info">
            <h3>{{shopInfo.shopname}}</h3>
            <div class="shop-details">
              <div>
                <span class="verified">认证商家</span>
                <span class="rating">
                  <span v-for="start in shopInfo.shopstart" :key="start">★</span>
                </span>
              </div>
              <div class="shop-name" @click="handleCredential">
                <span class="location">{{shopInfo.address}}</span>
                <img src="../assets/right.png"/>
              </div>
            </div>
          </div>
          <!-- <div class="shop-actions">
            <button class="follow-btn">+ 关注</button>
            <button class="support-btn">
              <img src="../assets/comst.png"/>客服</button>
          </div> -->
        </div>
      </header>
      <!-- <nav class="shop-nav">
        <button :class="{ active: currentTab === 'all' }" @click="currentTab = 'all'">全部</button>
        <button :class="{ active: currentTab === 'price' }" @click="currentTab = 'price'">价格</button>
        <button :class="{ active: currentTab === 'new' }" @click="currentTab = 'new'">上新</button>
      </nav> -->
      <section class="products-list">
        <div v-for="product in shopInfo.landingpagelist" :key="product.id" class="product-card" @click="addToCart(product)">
          <img class="product-image" :src="product.carousel_picture_src[0]">
          <div class="product-info">
            <h2>{{ product.product_name }}</h2>
            <p>{{ product.product_info_title }}</p>
            <div class="price">¥{{ product.price }}</div>
            <!-- <div class="sold">已售{{ product.sold }}</div> -->
          </div>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
  import {
    getShopGoods
  } from "../utils/api"

export default {
  data() {
    return {
      currentTab: 'all',
      shopid:null,
      shopInfo:null
    };
  },
  created(){
    this.shopid = this.$route.query.id
    this.getShopList()
  },
  methods:{
    addToCart(product) {
      this.$router.push({
        name: 'shopping',
        query: {
          code_id: product.landing_page_info_code,
          clickid:'2024'
        }
      })
      // 这里可以添加更多的逻辑，比如更新购物车显示、保存购物车状态等
    },
    //查看
    handleCredential(){
      this.$router.push({
        name: 'credential',
        query: this.shopInfo
      })
    },
    //获取店铺信息
    getShopList(){
      getShopGoods({shopid:this.shopid}).then(res=>{
        res.data.landingpagelist.forEach(item=>{
          item.carousel_picture_src = item.carousel_picture_src.split(',')
        })
        this.shopInfo = res.data
      })
    }
  }
};
</script>

<style scoped>
  .maxwidht {
    max-width: 500px;
    margin: 0 auto;
  }
.shop-page {

  font-family: Arial, sans-serif;
  background-color: #f8f8f8;
  /* padding: 20px; */
}

.shop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f53e3e;
  padding: 10px;
  color: #fff;
  border-radius: 8px;
}

.header-content {

  width: 100%;
  display: flex;
  align-items: center;
}

.header-logo{
  margin: 0px 20px;
}

.shop-logo {
  width: 70px;
  height: 70px;
  margin-right: 10px;
  border-radius: 40px;
}

.shop-info {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.shop-name{
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.shop-name img{
  width: 20px;
}

.shop-details {
  /* display: flex; */
  /* align-items: center; */
}

.verified {
  background-color: #ffc107;
  padding: 2px 5px;
  border-radius: 4px;
  margin-right: 10px;
}

.rating {
  margin-right: 10px;
}

.shop-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.follow-btn{
  background-color: #fff;
  color: #f53e3e;
  padding: 5px 10px;
}

.support-btn img{
  width: 10px;
}
.support-btn{
  background: none;
  border: 2px solid #fff !important;
  color: #fff;
  padding: 5px 8px;
}
.follow-btn, .support-btn {
  border: none;
  border-radius: 15px;
  margin-top: 5px;
  cursor: pointer;
}

.shop-nav {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 10px 0;
  margin: 10px 0;
  border-radius: 8px;
}

.shop-nav button {
  background: none;
  border: none;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.shop-nav .active {
  color: #f53e3e;
  font-weight: bold;
}

.products-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.product-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.product-card img {
  width: 100%;
  border-radius: 8px;
}

.product-info {
  padding: 10px 0;
}
.product-image{
  height: 200px;
}
.product-info h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.price {
  font-size: 16px;
  color: #f53e3e;
  font-weight: bold;
}

.sold {
  font-size: 14px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/shopstore.vue